import { render } from "./CommissionFormView.vue?vue&type=template&id=95c74442&scoped=true"
import script from "./CommissionFormView.vue?vue&type=script&lang=js"
export * from "./CommissionFormView.vue?vue&type=script&lang=js"

import "./CommissionFormView.vue?vue&type=style&index=0&id=95c74442&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c74442"]])

export default __exports__